import { IconPlayerPause } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { isNonNullish } from 'remeda';
import { useLoadPausedInvoices } from 'shared/hooks/use-load-paused-invoices';
import { useSafeLocalizedCompactCurrencyFormatter } from 'shared/utils/currency';

import { BaseTicker } from '../BaseTicker';

function getSharePaused(pausedAmount: number, totalAmount: number) {
  return pausedAmount / totalAmount;
}

export const PausedTicker = () => {
  const { t } = useTranslation();
  const { pausedInvoices, pausedInvoicesError, isPausedInvoicesLoading } = useLoadPausedInvoices();
  const formatter = useSafeLocalizedCompactCurrencyFormatter();

  if (isPausedInvoicesLoading || pausedInvoices == null) {
    return (
      <BaseTicker
        icon={IconPlayerPause}
        label={t(i18nKeys.ANALYTICS.TICKERS.PAUSED.TITLE)}
        hasFailed={isNonNullish(pausedInvoicesError)}
      />
    );
  }

  return (
    <BaseTicker
      icon={IconPlayerPause}
      label={t(i18nKeys.ANALYTICS.TICKERS.PAUSED.TITLE)}
      value={formatter.format(pausedInvoices.totalInvoicesPaused)}
      share={getSharePaused(pausedInvoices.totalInvoicesPaused, pausedInvoices.totalInvoices)}
      url="/invoices?&status=paused"
    />
  );
};
